import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRemoveSocialClipV1Response } from './remove-social-clip-v1-response';
import { removeSocialClipV1ResponseSchema } from './remove-social-clip-v1-response';

export async function removeSocialClipV1Api(
  clipId: number,
): Promise<IValidatedResponse<IRemoveSocialClipV1Response>> {
  return postRequest<IRemoveSocialClipV1Response>({
    path: `/sys/social/v1/clips/${clipId}/remove`,
    schema: removeSocialClipV1ResponseSchema,
  });
}
